import React, { useEffect, useState } from "react";
import { Step, StepContent, StepLabel, Stepper } from "@material-ui/core";
import ConvertToCustomerForm from "../../../crm/leads/convertToCustomerForm";
import ConvertToSalesOrderForm from "./convertToSalesOrderForm";
import { getQuotation } from "../../../../../services/sales/quotationService";
import { getPredefinedTOCs } from "../../../../../services/commons";
import { closeWonSalesOrder } from "../../../../../services/crm/salesCardService";
import { Typography } from "@material-ui/core";
import Swal from "sweetalert2";
import { sendApprovalRequests } from "../../../../../utils/utils";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import store from "../../../../../store/store";
function ConvertToSalesOrderWizard({
  history,
  quotationID,
  onCloseDialog,
  onConfirmSave,
}) {
  const { socket } = useGlobalData();
  const { auth } = store.getState();
  const { fullName } = auth.user;
  const [quotation, setQuotation] = useState({
    ID: 0,
    customerID: 0,
    leadID: 0,
  });
  const [activeStep, setActiveStep] = useState(0);
  const [convertToCustomer, setConvertToCustomer] = useState({});
  const [salesOrder, setSalesOrder] = useState({});
  const [createOps, setCreateOps] = useState(false);
  const [salesOrderTOCs, setSalesOrderTOCs] = useState([]);
  const [customerAddressDefault, setCustomerAddressDefault] = useState(true);
  const [customerTOCDefault, setCustomerTOCDefault] = useState(true);
  const [salesOrderTOCDefault, setSalesOrderTOCDefault] = useState("");
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    getQuotationData(quotationID);
    getSalesOrderTOCData("SORD");
  }, [quotationID]);
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      <Step key="ctc">
        <StepLabel>
          <Typography variant="h6" className="kt-font-bolder">
            {quotation.customerID > 0
              ? "The client is a Customer already"
              : "Convert Lead to a Customer"}
          </Typography>
        </StepLabel>
        <StepContent>
          <ConvertToCustomerForm
            history={history}
            salesCardID={quotation.ID}
            lead={quotation.lead}
            onConfirmSave={(customer) => {
              setConvertToCustomer(customer);
              handleNext();
            }}
            onCloseDialog={() => {
              onCloseDialog();
            }}
          />
        </StepContent>
      </Step>
      <Step key="cts">
        <StepLabel>
          <Typography variant="h6" className="kt-font-bolder">
            Convert Quotation to Sales Order
          </Typography>
        </StepLabel>
        <StepContent>
          {quotation.ID > 0 ? (
            <ConvertToSalesOrderForm
              salesCardID={quotation.salesCardID}
              quotation={quotation}
              salesOrderTOCs={salesOrderTOCs}
              customerAddressDefault={customerAddressDefault}
              handleCustomerAddressDefault={handleCustomerAddressDefault}
              customerTOCDefault={customerTOCDefault}
              handleCustomerTOCDefault={handleCustomerTOCDefault}
              salesOrderTOCDefault={salesOrderTOCDefault}
              onBackDialog={() => {
                handleBack();
              }}
              onCloseDialog={() => {
                onCloseDialog();
              }}
              onConfirmSave={(salesOrder) => {
                setSalesOrder(salesOrder);
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                })
                  .fire({
                    title:
                      "Are you sure want to convert this Quotation to Sales Order ?",
                    text:
                      "Please note that you are responsible for this action",
                    icon: "question",
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, convert it`,
                    cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                    reverseButtons: true,
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      closeWonSalesOrder(convertToCustomer, salesOrder, {
                        ID: 0,
                        title: "",
                      }).then((response) => {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Converted",
                          html: response.data.message,
                          icon: "success",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });

                        let toUsers = [];
                        const { data } = response.data;

                        if (
                          data.notificationToUsers &&
                          data.notificationToUsers.length > 0
                        ) {
                          data.notificationToUsers.map(
                            (notificationToUser, index) => {
                              toUsers.push({
                                ID: notificationToUser.toUserID,
                              });
                            }
                          );
                        }

                        if (toUsers && toUsers.length > 0) {
                          sendApprovalRequests(socket, fullName, toUsers);
                        }

                        onConfirmSave();
                      });
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Cancelled",
                        text: "No change has been made",
                        icon: "info",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                    }
                  });
              }}
            />
          ) : null}
        </StepContent>
      </Step>
    </Stepper>
  );

  async function getQuotationData(quotationID) {
    const response = await getQuotation(quotationID);
    const { data } = response.data;
    setQuotation(data.quotation);
    if (data.quotation.customerID > 0) {
      setActiveStep(1);
    } else {
      setActiveStep(0);
    }
  }

  async function getSalesOrderTOCData(appCode) {
    getPredefinedTOCs(appCode)
      .then((response) => {
        const { data } = response.data;
        setSalesOrderTOCs(data.predefinedTOCs);
        const salesOrderTOCDefault = data.predefinedTOCs.filter(
          (soTOCDefault) => soTOCDefault.defaultTOC === true
        );
        if (salesOrderTOCDefault.length > 0) {
          setSalesOrderTOCDefault(salesOrderTOCDefault[0].toc);
        }
      })
      .catch((error) => {});
  }

  function handleCustomerAddressDefault() {
    setCustomerAddressDefault(false);
  }

  async function handleCustomerTOCDefault() {
    setCustomerTOCDefault(false);
  }
}

export default ConvertToSalesOrderWizard;
